import React from "react";

export default function Risikomanagement() {
	return (
		<>
			<div className="beratung_cont" id="risk_management">
				<h1>Risikomanagement</h1>
				<p>
					Die Identifikation von Risiken, deren Analyse und Bewertung sowie
					deren Steuerung und Überwachung - insbesondere von möglicherweise
					bestandsgefährdenden Risiken - sind Kernaufgaben des Managements.
					Dafür hat das Management im Rahmen seiner Organisationsverantwortung
					und Legalitätspflicht geeignete Maßnahmen zu treffen. Abhängig von
					Kriterien wie Unternehmensgröße, Kapitalmarktorientierung etc. ist zu
					entscheiden, wie das Risikomanagement im Unternehmen auszugestalten
					ist.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Umfassende Erfahrung im Design und Aufbau angemessener
						Risikomanagementsysteme
					</li>
					<li>
						Neben den “klassischen Risiken“ Berücksichtigung neuer Entwicklungen
						wie z.B. IDW PS 340 n.F. oder ESG-Risiken
					</li>
					<li>
						Weitreichende Erfahrung bei der Implementierung von
						Risikotragfähigkeitskonzepten
					</li>
					<li>
						Abrundung durch aussagekräftige Reportings und Handlungsempfehlungen
						(z.B. zur Minimierung der Risiken)
					</li>
				</ul>
				<p>
					Ein nichtvorhandenes Risikomanagement entspricht nicht den Erwartungen
					des Gesetzgebers sowie der Anteilseigner und kann existenzgefährdend
					sein. Neben den gesetzlichen Anforderungen steigt die Notwendigkeit
					eines aktiven Risikomanagements durch eine immer komplexer werdenden
					Prozesse und Umwelt.
				</p>
				<p>Die Feingeist Beratung unterstützt Sie bei umfassend bei </p>
				<ul className="typeset-u-list">
					<li>
						Identifikation, Bewertung, Steuerung, Überwachung und Reporting der
						Risiken
					</li>
					<li>
						Aufbau eines angemessenen Risikomanagement-Systems inkl.
						Software-Auswahl
					</li>
					<li>der Steuerung Ihrer Risiken.</li>
				</ul>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
